import React, { useMemo } from 'react';

import Mention from '@tiptap/extension-mention';
import { Placeholder } from '@tiptap/extension-placeholder';
import StarterKit from '@tiptap/starter-kit';

import { RichTextFormControl } from './components/RichTextFormControl';
import { render } from './components/Suggestion';

const EMPTY_HTML = '<p></p>';
export const HTMLRichText = ({
  name,
  label,
  value,
  error,
  placeholder,
  autofocus,
  onChange,
  helperText: propsHelperText,
  loadMentions,
  showToolbar = false,
}) => {
  const helperText = useMemo(() => {
    let text = propsHelperText || error;
    if (loadMentions) {
      text = text || 'Tag users with an @ symbol';
    }
    return text;
  }, [loadMentions, propsHelperText, error]);

  const extensions = useMemo(() => {
    let result = [StarterKit];
    if (loadMentions) {
      result.push(
        Mention.configure({
          HTMLAttributes: {
            class: 'mention',
          },
          suggestion: {
            items: async ({ query }) => {
              return await loadMentions({ query });
            },
            render: render,
          },
        })
      );
    }
    if (placeholder) {
      result.push(
        Placeholder.configure({
          placeholder: placeholder,
        })
      );
      return result;
    }
    return result;
  }, [loadMentions, placeholder, render]);

  const handleUpdateEditor = ({ onChange: inputOnChange, editor }) => {
    const newValue = editor.getHTML();
    const normalizedValue = newValue === EMPTY_HTML ? undefined : newValue;
    inputOnChange({ target: { value: normalizedValue } }, normalizedValue);
  };

  return (
    <RichTextFormControl
      showToolbar={showToolbar}
      value={value}
      onChange={onChange}
      name={name}
      label={label}
      error={error}
      autofocus={autofocus}
      helperText={helperText}
      extensions={extensions}
      onUpdateEditorCallback={handleUpdateEditor}
    />
  );
};
